package br.com.duoma.duomaproducao.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.navigation.NavDestination.Companion.hasRoute
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import androidx.navigation.toRoute
import br.com.duoma.duomaproducao.model.WorkCenter
import br.com.duoma.duomaproducao.ui.screens.DashboardScreen
import br.com.duoma.duomaproducao.ui.screens.WorkCenterDetailsScreen
import br.com.duoma.duomaproducao.ui.theme.ProducaoTheme
import br.com.duoma.duomaproducao.viewmodel.ProducaoViewModel
import components.AppHeader

val VIEW_MODEL = ProducaoViewModel()
interface Screen {
    val route : String
}
@Composable
fun App() {
    val navController = rememberNavController()

    val executionInfo = VIEW_MODEL.workCenters.collectAsState().value
    val errorMessage = VIEW_MODEL.errorMessage.collectAsState().value

    ProducaoTheme {
        Column(
            Modifier.fillMaxSize().background(MaterialTheme.colorScheme.background),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            val dest = navController.currentBackStackEntryAsState().value?.destination
            val isDashboard = dest?.hasRoute<DashboardScreen>() == true
            AppHeader(!isDashboard, VIEW_MODEL.isLoading.collectAsState().value,
                {
                if (!isDashboard) navController.popBackStack()
            }) {
                VIEW_MODEL.updateWorkcenters()
            }
            if (errorMessage != null) {
                Surface(
                    modifier = Modifier.fillMaxWidth(),
                    color = MaterialTheme.colorScheme.errorContainer,
                    contentColor = MaterialTheme.colorScheme.onErrorContainer
                ) {
                    SelectionContainer {
                        Text(
                            text = errorMessage,
                            modifier = Modifier.padding(horizontal = 16.dp, vertical = 10.dp),
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                }
            }
//            LaunchedEffect(dest) {
//                if (dest == null) navController.navigate(DashboardScreen)
//            }
            NavHost(
                navController = navController, startDestination = DashboardScreen
            ) {
                composable<DashboardScreen> {
                    DashboardScreen(executionInfo) { navController.navigate(WorkCenterDetailsScreen(it.name)) }
                }
                composable<WorkCenterDetailsScreen> {
                    val wc = it.toRoute<WorkCenterDetailsScreen>()
                    val workCenter = WorkCenter.valueOf(wc.workCenterName)
                    val executions = executionInfo[workCenter] ?: emptyList()
                    WorkCenterDetailsScreen(workCenter, executions)
                }
            }
        }
    }
}
